import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { useCreateMealPlan } from "@/hooks/features/use-create-meal-plan";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useIonRouter } from "@ionic/react";
import MealCreatingProgress from "../../components/meal-creating-progress";

export default function OnboardingCreatingSuggestions() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();
  const { allGenerationStatus } = useCreateMealPlan(() => {
    navigation.push(info?.nextPath ?? "", "none");
  });

  return (
    <ProfilePageContainer
      showToolbar={false}
      className="h-full flex flex-col items-center justify-center"
    >
      <MealCreatingProgress statues={allGenerationStatus?.statuses} />
    </ProfilePageContainer>
  );
}
